import { getUserObject, logout } from "./sessionmain";

function updateHeaderContent() {
    const userObject = getUserObject();
    const accountLinkElem = document.querySelector<HTMLElement>('#top-nav-account');
    const firstNameElem = document.querySelector<HTMLElement>('#top-nav-firstname');
    const accountNameElem = document.querySelector<HTMLElement>('#top-nav-accountname');
    const footerSignoutElem = document.querySelector<HTMLElement>('#footer-signout');
    const navSignoutElem = document.querySelector<HTMLElement>('#top-nav-signout');
    const accountIconElem = document.querySelector<HTMLElement>('#top-nav-account-icon');
    const loginIconElem = document.querySelector<HTMLElement>('#top-nav-login-icon');

    if (userObject.IsAuthenticated === true) {
        accountIconElem?.classList.remove('hidden');
        accountIconElem?.removeAttribute('aria-hidden');
        loginIconElem?.classList.add('hidden');
        loginIconElem?.setAttribute('aria-hidden', "true");
        footerSignoutElem?.classList.remove('hidden');
        footerSignoutElem?.addEventListener('click', signoutClicked);
        navSignoutElem?.addEventListener('click', signoutClicked);
        if (firstNameElem !== null) {
            firstNameElem.innerText = userObject.FirstName;
        }
        if (accountNameElem !== null) {
            accountNameElem.innerText = userObject.NameAbbreviation;
        }
        if (accountLinkElem !== null) {
            accountLinkElem.ariaLabel = "Profile dashboard";
        }
    }
    else {
        accountIconElem?.classList.add('hidden');
        accountIconElem?.setAttribute('aria-hidden', "true");
        loginIconElem?.classList.remove('hidden');
        loginIconElem?.removeAttribute('aria-hidden');
        footerSignoutElem?.classList.add('hidden');
        if (firstNameElem !== null) {
            firstNameElem.innerText = 'Sign in';
        }
        if (accountNameElem !== null) {
            accountNameElem.innerText = 'Sign in';
        }
        if (accountLinkElem !== null) {
            accountLinkElem.ariaLabel = "Sign in";
        }
    }
}

function accountLinkClicked(evt: Event) {
    const userObject = getUserObject();
    const elem = (<HTMLElement>evt.target);

    if (userObject.IsAuthenticated === false) {
        elem.classList.add('pointer-events-none');
        elem.classList.add('opacity-70');
    }
}

function signoutClicked() {
    logout();
}

function bindHeaderElements() {
    document.querySelector<HTMLElement>('#top-nav-account')?.addEventListener('click', accountLinkClicked);
}

export function updateSessionUI() {
    bindHeaderElements();
    updateHeaderContent();
}
